import { useApp } from "@/context/AppContext";
import { mediaSrc } from "@/lib/api";
import AmbientSound from "@/components/journey/AmbientSound";
import Tm from "@/components/journey/Tm";

export const Logo = ({ size = "h-11 w-11" }) => {
  const { settings } = useApp();
  const src = mediaSrc(settings?.media?.logo);
  if (!src) return null;
  return (
    <span data-testid="site-logo" className={`${size} inline-block shrink-0 overflow-hidden rounded-full bg-white ring-2 ring-amber-200/40`}>
      <img src={src} alt="Joyful Minds logo" className="h-full w-full scale-[1.6] object-cover" />
    </span>
  );
};

export default function TopBar({ soundRef }) {
  const { state, update } = useApp();
  return (
    <header className="relative z-20 flex items-center justify-between px-4 py-3 sm:px-10 sm:py-4">
      <div className="flex items-center gap-3">
        <Logo />
        <span className="font-display text-sm font-semibold tracking-[0.25em] text-emerald-50">JOYFUL MINDS<Tm sizeEm={0.65} /></span>
      </div>
      <div className="flex items-center gap-2">
        {state.lang && (
          <div className="glass flex rounded-full p-1" data-testid="language-toggle">
            {[["en", "EN"], ["ml", "മല"]].map(([code, label]) => (
              <button
                key={code}
                type="button"
                data-testid={`language-toggle-${code}`}
                onClick={() => update({ lang: code })}
                className={`rounded-full px-3 py-1 text-xs transition-colors ${state.lang === code ? "bg-emerald-400 text-emerald-950" : "text-emerald-100 hover:text-white"}`}
              >
                {label}
              </button>
            ))}
          </div>
        )}
        <AmbientSound ref={soundRef} />
      </div>
    </header>
  );
}
